export const DEFAULT_NINJA_BETA_LINK = 'https://www.ninjatech.ai/';
export const DEFAULT_PRIVACY_POLICY_LINK = 'https://www.ninjatech.ai/privacy';

export const DEFAULT_TERMS_OF_SERVICE_LINK =
  'https://www.ninjatech.ai/terms-of-service';

export const DEFAULT_ACCEPTABLE_USE_POLICY =
  'https://www.ninjatech.ai/acceptable-use-policy';

export const DEFAULT_NINJATECH_LINK = 'https://www.ninjatech.ai';
export const DEFAULT_NINJATECH_BLOG_LINK = 'https://www.ninjatech.ai/news';
export const DEFAULT_NINJATECH_FAQ_LINK = 'https://www.ninjatech.ai/faq';
export const DEFAULT_NINJATECH_PRICING_LINK =
  'https://www.ninjatech.ai/pricing';

export const LEARN_MORE_PRICES_LINK =
  'https://www.ninjatech.ai/pricing#compare-plans';
export const PAY_PER_USE = 'https://www.ninjatech.ai/pricing#pay-per-use';
export const RATE_LIMIT = 'https://www.ninjatech.ai/pricing#rate-limits';
export const AI_MODELS_PRICING = 'https://www.ninjatech.ai/pricing#ai-models';

export const EXTERNAL_MODELS_LINK =
  'https://www.ninjatech.ai/product/external-model-access#all-models';

export const SUPER_AGENT = 'https://www.ninjatech.ai/product/super-agent';
export const SUPER_AGENT_REASONING =
  'https://www.ninjatech.ai/product/super-agent';
export const DEEP_RESEARCH = 'https://www.ninjatech.ai/product/deep-research';
export const IMAGE_GEN = 'https://www.ninjatech.ai/product/ai-image-generator';
export const IMAGE_EDITOR = 'https://www.ninjatech.ai/product/ai-image-editor';
export const IMAGE_GENERATION =
  'https://help.myninja.ai/hc/en-us/articles/30439417358231-Best-Practices-for-Image-Generation';
export const CODER = 'https://www.ninjatech.ai/product/ai-code-generator';
export const SCHEDULER = 'https://www.ninjatech.ai/product/ai-scheduling-agent';
export const WRITER = 'https://www.ninjatech.ai/product/ai-writer';
export const FILE_AGENT =
  'https://www.ninjatech.ai/product/file-upload-analysis';
export const API_DOC_LINK = 'https://www.ninjatech.ai/product/api-quick-start';
export const SUPERNINJA_GUIDE =
  'http://www.ninjatech.ai/blog/superninja-your-complete-guide';

export const ONBOARDING_IMAGE_MOBILE =
  'https://ninjatech-mainwebsite.s3.us-west-2.amazonaws.com/Mobile_Onboarding_Modal.jpg';

export const ONBOARDING_IMAGE_DESKTOP =
  'https://ninjatech-mainwebsite.s3.us-west-2.amazonaws.com/Desktop_Onboarding_Modal.jpg';

export const WELCOME_PRO_TRIAL_IMAGE =
  'https://ninjatech-mainwebsite.s3.us-west-2.amazonaws.com/Welcome_to_ninja_pro_trial.gif';

export const DESKTOP_APP_DOWNLOAD_LATEST =
  'https://api.github.com/repos/NinjaTech-AI/desktop-app/releases/latest';
export const DESKTOP_APP_RELEASES_LATEST =
  'https://github.com/NinjaTech-AI/desktop-app/releases/latest';

export const EXTERNAL_MODELS_IMAGE_DARK =
  'https://ninjatech-mainwebsite.s3.us-west-2.amazonaws.com/brand_logos_dark_mode.jpg';

export const EXTERNAL_MODELS_IMAGE_LIGHT =
  'https://ninjatech-mainwebsite.s3.us-west-2.amazonaws.com/brand_logos_light_mode.jpg';

export const LEARN_MORE_ADVANCED_CODING =
  'https://www.ninjatech.ai/news/ninjatech-ai-achieves-state-of-the-art-humaneval-benchmark-with-new-agentic-workflow-for-codegen';

export const LEARN_MORE_VIDEO_GEN =
  'https://www.ninjatech.ai/product/ai-video-generator';

export const RANDOM_VIDEOS = [
  'https://d1h34sttp1evgt.cloudfront.net/Astronaut_watching_fireworks_dog.mp4',
  'https://d1h34sttp1evgt.cloudfront.net/Seashell_on_beach.mp4',
  'https://d1h34sttp1evgt.cloudfront.net/Cheeseburger_dolly_pan.mp4',
  'https://d1h34sttp1evgt.cloudfront.net/Flying_butterflies_neon_forest.mp4',
  'https://d1h34sttp1evgt.cloudfront.net/Campfire_in_forest.mp4',
  'https://d1h34sttp1evgt.cloudfront.net/Mountain_range_view.mp4',
];

export const RANDOM_DEEP_RESEARCHER_VIDEOS = [
  'https://d1h34sttp1evgt.cloudfront.net/Deep_Researcher_Upsell_1.mp4',
];

export const IOS_MOBILE_APP_LINK =
  'https://apps.apple.com/ca/app/ninja-ai/id6702030312';

export const HELP_CENTER_LINK = 'https://help.myninja.ai/hc/en-us';

export const HELP_CENTER_GETTING_STARTED_LINK =
  'https://help.myninja.ai/hc/en-us/categories/29530945542039-Ninja-AI';

export const HELP_CENTER_ACCOUNT_LOGIN_BILLING_LINK =
  'https://help.myninja.ai/hc/en-us/categories/29530907018903-Account-login-and-billing';

export const NINJA_TUTORIALS = [
  {
    title: 'How to Prompt Ninja: Talk to It Like a Human',
    description:
      'Learn how easy it is to communicate with Ninja. Simply communicate naturally—just like you would with a colleague—and let Ninja take care of the rest. Whether you’re writing emails, fixing code, or diving into research, Ninja automatically chooses the right tool to help you, no tech jargon required.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Tutorial_1_Natural_Conversation.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Ninja_Tutorial_1_Poster.jpg',
    duration: '1:47',
  },
  {
    title: 'Maximize Prompt Results: Simple Features That Unlock Greater Power',
    description:
      'Ready to take your Ninja experience to the next level? Tap into two simple features that will revolutionize your workflow. The Prompt Improver helps you get more precise, tailored results, while Skill Modes automatically optimize your requests based on the task at hand.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Tutorial_2_Advanced_Tricks_Better_Results.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Ninja_Tutorial_2_Poster.jpg',
    duration: '1:56',
  },
  {
    title:
      'Migrating from Other AI Tools: Leverage 20+ Premium Models in One Place',
    description:
      'Migrating from ChatGPT, Claude, or another AI tool? Learn how to continue using the models you love in Ninja, with customizable settings and smart auto-selection that make the transition seamless and efficient.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Tutorial_3_Migrating_Tools.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Ninja_Tutorial_3_Poster.jpg',
    duration: '2:11',
  },
];

export const SUPER_NINJA_TUTORIALS = [
  {
    title: 'Creating Projects and Managing Files in SuperNinja',
    description:
      'How to create a project, add files, and create a .zip file with SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Projects_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Projects_Tutorial_Thumbnail.jpg',
    duration: '2:59',
  },
  {
    title: 'Creating a Shareable Link',
    description:
      'How to create a publicly shareable link of your SuperNinja chat.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Sharelink_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Create_Link_Tutorial_Thumbnail.jpg',
    duration: '0:25',
  },
  {
    title: 'Creating a Website in SuperNinja',
    description:
      'How to create a no-code website and deploy it to a shareable URL, all with SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Create_Website_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Website_Tutorial_Thumbnail.jpg',
    duration: '6:44',
  },
  {
    title: 'Managing Disk Space in SuperNinja',
    description:
      'How to manage the disk space of each SuperNinja thread & virtual machine.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Managing_Storage_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/VM_storage_Tutorial_Thumbnail.jpg',
    duration: '2:37',
  },
  {
    title: 'Research and Create an Excel File',
    description:
      'How to research and organize complex data into a spreadsheet using SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Create_Excel_File_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Excel_file_Tutorial_Thumbnail.jpg',
    duration: '3:17',
  },
  {
    title: 'Generating an Image in SuperNinja',
    description: 'How to generate an image within SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Generating_Images_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Generating_images_Tutorial_Thumbnail.jpg',
    duration: '1:11',
  },
  {
    title: 'Research and Create a Slideshow With SuperNinja',
    description:
      'How to conduct deep research on a subject and create a shareable slideshow with SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Create_Presentations_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Presentations_Tutorial_Thumbnail.jpg',
    duration: '2:48',
  },
  {
    title: 'Branching a Chat Into a New Thread',
    description: 'How to branch an existing chat thread into a new one.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Continue_Conversation_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Continue_response_Tutorial_Thumbnail.jpg',
    duration: '2:21',
  },
  {
    title: 'Fast/Complex/Standard modes',
    description: 'How and when to use Fast/Complex/Standard modes.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Standard-Complex-Fast_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Fast-Complex-Standard_Mode_Tutorial_Thumbnail.jpg',
    duration: '2:59',
  },
  {
    title: 'Adding Memory (Knowledge) in SuperNinja',
    description: 'How to Add a Memory (Knowledge) in SuperNinja.',
    url: 'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Knowledge_Tutorial_SuperNinja.mp4',
    thumbnail:
      'https://d1h34sttp1evgt.cloudfront.net/Ninja_Tutorials/Knowledge_Tutorial_Thumbnail.jpg',
    duration: '2:51',
  },
];

export const SUPER_NINJA_ONBOARDING_VIDEO =
  'https://d1h34sttp1evgt.cloudfront.net/Super_Agent_Open_Tier_Video.mp4';
